import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


const state = {
  // openid: Cookies.get('_openid'),
  username: null
  // avatar: null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}




// WEBPACK FOOTER //
// ./src/store/wechat/index.js